import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { Inject, Prop, Watch } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import V3DatePicker from 'vue3-datepicker';
import {
  InvestigationView,
  LeaveEntryRequest,
  LeaveType,
  TimeEntryActivity,
  TimeEntryRequest,
  TimeEntryType,
  TimeEntryView,
  TrustTeamMemberView,
} from '@/shared/modules/typescript-trustapi-client/models';
import CalendarView from '@/shared/components/calendar-view/index.vue';
import moment from 'moment';
import { EventInput, ViewApi } from '@fullcalendar/core';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { eventPublicHolidayTransform, eventTransform } from '@/shared/components/helpers';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { orderBy } from 'lodash';
import { EventForm } from './event-form';

@Options({
  components: {
    ModalBox,
    V3DatePicker,
    LoadingIndicator,
    ErrorIndicator,
    CalendarView,
  },
  mixins: [FormatDateTimeMixin],
})
export default class AddEventModal extends Vue {
  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Inject({ from: 'leaveType', default: [] })
  private leaveType!: LeaveType[];

  @Inject({ from: 'timeEntryType', default: [] })
  private timeEntryType!: TimeEntryType[];

  @Inject({ from: 'timeEntryActivity', default: [] })
  private timeEntryActivity!: TimeEntryActivity[];

  @Prop({ default: { id: 0, eventTypeId: 1 } })
  private eventFormData!: EventForm;

  private ai = new AppInsights();

  private currentCalendarView: ViewApi = null as any;
  private loadingEvents = false;

  private submitting = false;
  private loadingContent = false;
  private errorLoadingContent = false;
  private showCancelAlert = false;

  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private startDate = new Date();
  private startTime = '';
  private endDate = new Date();
  private endTime = '';

  private investigators: TrustTeamMemberView[] = [];
  private investigationList: InvestigationView[] = [];
  private eventData: EventInput[] = [];

  private formData: EventForm = {};

  @Watch('formData.trustTeamMemberId')
  onTrustTeamMemberChanged(): void {
    if (this.currentCalendarView) {
      this.getEvents(this.currentCalendarView);
    }
  }

  @Watch('formData.activityType')
  onActivityTypeChanged(): void {
    this.formData.investigation = this.formData.activityType?.isInvestigation
      ? this.formData?.investigation
      : { id: null };
  }

  created(): void {
    this.init();
  }

  mounted(): void {
    this.preloadData();
  }

  private init(): void {
    this.formData = JSON.parse(JSON.stringify(this.eventFormData));

    this.formData.id = this.formData.id ?? 0;
    this.formData.trustTeamMemberId = this.formData.trustTeamMemberId ?? (null as any);
    this.formData.eventTypeId = this.formData.eventTypeId ?? 2;
    this.formData.activityType = this.formData.activityType ?? (null as any);
    this.formData.investigation = this.formData.investigation ?? { id: null };
    this.formData.leaveTypeId = this.formData.leaveTypeId ?? (null as any);

    this.startDate = this.formData.startDateTime ? new Date(this.formData.startDateTime) : new Date();
    this.startTime = moment(this.startDate).format('HH:mm');

    if (!this.editMode && this.formData.eventTypeId == 2) {
      this.endDate = this.formData.startDateTime ? new Date(this.formData.startDateTime) : new Date();
      this.endTime = moment(this.endDate).format('HH:mm');
    } else {
      this.endDate = this.formData.endDateTime ? new Date(this.formData.endDateTime) : new Date();
      this.endTime = moment(this.endDate).format('HH:mm');
    }
    // console.log(this.formData);
  }

  // private saveEvent(): void {
  //   if (this.formData.eventTypeId == 1) {
  //     this.saveTimeEntry();
  //   } else {
  //     this.saveLeaveTimeEntry();
  //   }
  // }

  // private async saveLeaveTimeEntry(): Promise<void> {
  //   try {
  //     if (!this.validForm && !this.isFormDirty) {
  //       throw new Error('Invalid Data Filled');
  //     }
  //     this.submitting = true;
  //     const leaveEntryReq: LeaveEntryRequest = {
  //       id: this.formData.id,
  //       trustTeamMemberId: this.formData.trustTeamMemberId,
  //       leaveTypeId: this.formData.leaveTypeId,
  //       startDateTime: this.localToUTCString(this.startDate, this.startTime),
  //       endDateTime: this.localToUTCString(this.endDate, this.endTime),
  //       notes: this.formData.notes,
  //     };
  //     const resp: any = await this.apiService.TimeEntryApi?.apiV2TimeEntrySaveLeaveTimeEntryPost(leaveEntryReq);
  //     this.eventCtrl.emit('show-snackbar', 'success', 'Updated Successfully');
  //     this.eventCtrl.emit('reload-events-data');
  //     this.closeModal();
  //   } catch (err) {
  //     this.eventCtrl.emit('show-snackbar', 'error', 'Unable to process request');
  //   } finally {
  //     this.submitting = false;
  //   }
  // }

  // private async saveTimeEntry(): Promise<void> {
  //   try {
  //     if (!this.validForm && !this.isFormDirty) {
  //       throw new Error('Invalid Data Filled');
  //     }
  //     this.submitting = true;
  //     const timeEntryReq: TimeEntryRequest = {
  //       id: this.formData.id,
  //       trustTeamMemberId: this.formData.trustTeamMemberId,
  //       breakDuration: this.formData.breakDuration,
  //       investigationId: this.formData.activityType?.isInvestigation ? this.formData.investigation?.id : null,
  //       timeEntryActivityId: this.formData.activityType?.id ?? null,
  //       startDateTime: this.localToUTCString(this.startDate, this.startTime),
  //       endDateTime: this.localToUTCString(this.startDate, this.endTime),
  //       notes: this.formData.notes,
  //       description: [11].includes(this.formData.activityType?.id) ? this.formData.description : null,
  //     };
  //     const resp: any = await this.apiService.TimeEntryApi?.apiV2TimeEntrySaveTimeEntryPost(timeEntryReq);
  //     this.eventCtrl.emit('show-snackbar', 'success', 'Updated Successfully');
  //     this.eventCtrl.emit('reload-events-data');
  //     this.closeModal();
  //   } catch (err) {
  //     this.eventCtrl.emit('show-snackbar', 'error', 'Unable to process request');
  //   } finally {
  //     this.submitting = false;
  //   }
  // }

  // private async deleteEvent(): Promise<void> {
  //   try {
  //     this.submitting = true;
  //     await this.apiService.TimeEntryApi?.apiV2TimeEntryDeleteTimeEntryTimeEntryIdDelete(this.formData.id);
  //     this.eventCtrl.emit('show-snackbar', 'success', 'Event deleted successfully');
  //     this.eventCtrl.emit('reload-events-data');
  //     this.closeModal();
  //   } catch (err) {
  //     this.eventCtrl.emit('show-snackbar', 'error', 'Unable to delete event');
  //   } finally {
  //     this.submitting = false;
  //   }
  // }

  get validBreakDuration(): boolean {
    const startDateTime = this.localToUTCString(this.startDate, this.startTime);
    const endDateTime = this.localToUTCString(this.startDate, this.endTime);
    return (this.formData.breakDuration as any) < moment(endDateTime).diff(moment(startDateTime), 'minutes');
  }

  get validForm(): boolean {
    const chk1 = !!this.formData.trustTeamMemberId && this.formData.trustTeamMemberId > 0;
    const chk2 = !!this.formData.leaveTypeId && this.formData.leaveTypeId > 0;
    const chk3 = !!this.startDate;
    const chk4 = !!this.startTime;
    const chk5 = !!this.endDate;
    const chk6 = !!this.endTime;
    const chk7 = !!this.formData.activityType;
    const chk8 =
      this.formData.activityType?.isInvestigation &&
      !!this.formData.investigation &&
      this.formData.investigation.id > 0;
    const chk9 =
      [11].includes(this.formData.activityType?.id) &&
      !!this.formData.description &&
      this.formData.description.length > 0;
    const chk10 =
      ![11].includes(this.formData.activityType?.id) &&
      !this.formData.activityType?.isInvestigation &&
      this.formData.investigation?.id == null;
    const chk11 = !isNaN(this.formData.breakDuration as any) && parseInt(this.formData.breakDuration as any) >= 0;
    const startDateTime = this.localToUTCString(this.startDate, this.startTime);

    if (this.formData.eventTypeId == 1) {
      const endDateTime = this.localToUTCString(this.startDate, this.endTime);
      const dateTimeCheck = endDateTime > startDateTime;
      const breakDurationCheck =
        (this.formData.breakDuration as any) > moment(endDateTime).diff(moment(startDateTime), 'minutes');
      return (
        chk1 && chk3 && chk4 && chk6 && chk7 && (chk8 || chk9 || chk10) && chk11 && dateTimeCheck && !breakDurationCheck
      );
    } else if (this.formData.eventTypeId == 2) {
      const endDateTime = this.localToUTCString(this.endDate, this.endTime);
      const dateTimeCheck = endDateTime > startDateTime;
      return chk1 && chk2 && chk3 && chk4 && chk5 && chk6 && dateTimeCheck;
    } else {
      return false;
    }
  }

  get isFormDirty(): boolean {
    const chk1 = this.eventFormData.trustTeamMemberId != this.formData.trustTeamMemberId;
    const chk2 = this.eventFormData.leaveTypeId != this.formData.leaveTypeId;

    const chk3 =
      moment(this.formData.startDateTime ?? this.startDate).unix() !=
      moment(moment(this.startDate).format('YYYY-MM-DD'))
        .add(parseInt(this.startTime.split(':')[0]), 'h')
        .add(parseInt(this.startTime.split(':')[1]), 'm')
        .unix();

    const chk4 =
      moment(this.formData.endDateTime ?? this.endDate).unix() !=
      moment(moment(this.formData.eventTypeId == 1 ? this.startDate : this.endDate).format('YYYY-MM-DD'))
        .add(parseInt(this.endTime.split(':')[0]), 'h')
        .add(parseInt(this.endTime.split(':')[1]), 'm')
        .unix();

    const chk5 = this.eventFormData.breakDuration != this.formData.breakDuration;
    const chk6 = this.eventFormData.notes != this.formData.notes;
    const chk7 = this.eventFormData.activityType?.id != this.formData.activityType?.id;
    const chk8 =
      this.formData.activityType?.isInvestigation &&
      this.eventFormData.investigation?.id != this.formData.investigation?.id;
    const chk9 =
      [11].includes(this.formData.activityType?.id) && this.eventFormData.description != this.formData.description;

    if (this.formData.eventTypeId == 1) {
      return chk1 || chk3 || chk4 || chk5 || chk6 || chk7 || chk8 || chk9;
    } else if (this.formData.eventTypeId == 2) {
      return chk1 || chk2 || chk3 || chk4 || chk6;
    } else {
      return chk1 || chk2 || chk3 || chk4 || chk5 || chk6 || chk7 || chk8 || chk9;
    }
  }

  private async getEvents(view: ViewApi): Promise<void> {
    try {
      this.loadingEvents = true;
      const resp: any = await this.apiService.CalendarApi?.apiV2CalendarGetEventsByTrustTeamMemberIdPost({
        trustTeamMemberId: this.formData.trustTeamMemberId,
        startDate: new Date(view.activeStart),
        endDate: new Date(view.activeEnd),
        showMissingTime: false,
      });
      this.eventData = [...eventTransform(resp.data.data)];
    } catch (error) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get time events');
      this.ai.trackException('Error getting investigations: ' + error);
    } finally {
      this.loadingEvents = false;
    }
  }

  private async preloadData(): Promise<void> {
    try {
      this.loadingDataSet = true;
      this.errorLoadingDataSet = false;
      const resp: any[] = await Promise.all([
        this.apiService.InvestigationApi?.apiV2InvestigationGetInvestigationsPost(),
        this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetTrustTeamMembersPost(),
      ]);
      this.investigationList = resp[0].data.data as InvestigationView[];
      this.investigators = orderBy(
        resp[1].data.data as TrustTeamMemberView[],
        [(data) => data.displayName.toLowerCase()],
        'asc',
      );
      if (!this.editMode) {
        this.investigators = this.investigators.filter((x) => [2, 3, 5].includes(x.userGroup?.id));
      }
    } catch (err) {
      this.errorLoadingDataSet = true;
    } finally {
      this.loadingDataSet = false;
    }
  }

  private localToUTCString(date: Date, timeString: string) {
    const _localTime: string = moment(date).local().format('YYYY-MM-DD') + ' ' + timeString;
    return moment(_localTime).utc().format();
  }

  private closeModal() {
    this.$emit('closeAddEventModal');
  }

  private uiDateTimeRangeChanged(view: ViewApi): void {
    this.currentCalendarView = view;
    if (!!this.formData.trustTeamMemberId && this.formData.trustTeamMemberId > 0) {
      this.getEvents(view);
    }
  }

  get selectedInvestigation(): InvestigationView {
    if (this.editMode && this.formData.investigation) {
      return this.formData.investigation;
    } else {
      try {
        return this.filteredInvestigationList.filter((x) => x.id == this.formData.investigation?.id)[0];
      } catch {
        return null as any;
      }
    }
  }

  private getLeaveTypeName(id: number): string | null {
    return this.leaveType.find((x) => x.id == id)?.name ?? null;
  }

  get filteredInvestigationList(): InvestigationView[] {
    return this.investigationList.filter((x) => x.trustTeamMember?.id == this.formData.trustTeamMemberId);
  }

  get editMode(): boolean {
    return this.eventFormData?.id > 0;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get selectedTrustTeamMember(): TrustTeamMemberView {
    return store.getters.getSelectedTrustTeamMember;
  }

  private convertToAMPM(time: string): string {
    const [hours, minutes] = time.split(':').map(Number);
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const adjustedHours = hours % 12 || 12; // Convert 0 to 12 for AM/PM format
    return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${ampm}`;
  }
}
